import { render, staticRenderFns } from "./LeaveAgePopover.vue?vue&type=template&id=28c4a3f8&"
import script from "./LeaveAgePopover.vue?vue&type=script&lang=js&"
export * from "./LeaveAgePopover.vue?vue&type=script&lang=js&"
import style0 from "./LeaveAgePopover.vue?vue&type=style&index=0&id=28c4a3f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports